// General business costume v1 — the catch-all for any business that
// isn't one of the named industries. Plain, universal language so a
// first-time visitor never feels "this isn't for me".

export const OTHERS_COSTUME = {
  costumeId: "others_v1",

  stages: [
    { key: "new", label: "New" },
    { key: "spoke", label: "Spoke to them" },
    { key: "visit_scheduled", label: "Meeting scheduled" },
    { key: "visited", label: "Met them" },
    { key: "sent_price", label: "Sent quote" },
    { key: "signed_up", label: "Won" },
    { key: "lost", label: "Lost" },
  ],

  stageColors: {
    new: "bg-amber-100 text-amber-800 border-amber-200",
    spoke: "bg-orange-100 text-orange-800 border-orange-200",
    visit_scheduled: "bg-yellow-100 text-yellow-800 border-yellow-200",
    visited: "bg-emerald-100 text-emerald-800 border-emerald-200",
    sent_price: "bg-rose-100 text-rose-800 border-rose-200",
    signed_up: "bg-green-100 text-green-800 border-green-200",
    lost: "bg-zinc-200 text-zinc-700 border-zinc-300",
  },

  defaultSources: [
    "Walk-in",
    "Phone call",
    "Website",
    "Referral",
    "Social media",
    "WhatsApp",
    "Others",
  ],

  lostReasons: [
    "Price too high",
    "Chose someone else",
    "Just exploring",
    "Stopped responding",
    "Plan dropped",
    "Not the right fit",
    "Other",
  ],

  enquiryTypes: [
    "General enquiry",
    "Product",
    "Service",
    "Quote request",
    "Other",
  ],

  waTemplates: [
    { name: "First contact", body: "Hi {{name}}, this is {{me}} from {{company}}. Thanks for getting in touch — happy to help. When is a good time to talk?" },
    { name: "Meeting invite", body: "Hi {{name}}, would you like to set up a quick call or meeting? Just tell me a day and time that suits you." },
    { name: "Quote share", body: "Hi {{name}}, sharing the details as discussed: {{quote}}. Happy to walk you through it." },
    { name: "Soft follow-up", body: "Hi {{name}}, just checking in — any thoughts on what we discussed?" },
    { name: "Polite drop", body: "Hi {{name}}, hope all's well. Closing this for now; whenever you're ready, just ping me." },
  ],

  companyInfo: { name: "", me: "", address: "" },

  vocab: {
    unit: "item",
    units: "items",
    location: "location",
    locations: "locations",
    customer: "customer",
  },

  copy: {
    appName: "Jigyasa",
    sectionTrend: "Enquiries vs won — last 6 months",
    sectionAttention: "Needs your attention",
    attentionAllClear: "All caught up — nothing is waiting on you.",
    attentionWaitingQuote: "waiting after quote",
    remarksTitle: "Remarks & history",
    remarkPlaceholder: "e.g. Wants a callback on Saturday afternoon",
    addRemarkButton: "Add",
    remarksEmpty: "No remarks yet — add one after each call so the story stays in one place.",
    settingsSourcesTitle: "Manage enquiry sources",
    settingsSourcesNote: "Each organisation sets up its own list of where enquiries come from. Removing a source never changes past enquiries — it only affects new ones.",
    pastEnquiryBannerLabel: "Returning lead",
    pastEnquiryBannerNote: "We've spoken before — don't start cold.",
    footprintBannerLabel: "Already with us",
    footprintInlineDismiss: "This is someone new — clear and start fresh",
  },

  buttonsOn: {
    liveStock: false,
    upcomingStock: false,
    customerFootprint: false,
    pastEnquiries: true,
    pricingAndOffers: false,
    activityHistory: false,
    renewalPipeline: false,
    locationCatalog: false,
    satisfaction: false,
    availability: false,
    compliance: false,
    communications: false,
  },
};
